const utils = {

	/* 
	 * 获取url字符串参数
	 */
	getRequestParameters: function(locationhref) {
		let href = locationhref || "";
		let theRequest = new Object();
		let str = href.split("?")[1];
		if (str != undefined) {
			let strs = str.split("&");
			for (let i = 0; i < strs.length; i++) {
				theRequest[strs[i].split("=")[0]] = (strs[i].split("=")[1]);
			}
		}
		return theRequest;
	},


	//删除url后某个参数
	delParam: function(url, ref) {
		var str = "";
		if (url.indexOf('?') != -1)
			str = url.substr(url.indexOf('?') + 1);
		else
			return url;
		var arr = "";
		var returnurl = "";
		// var setparam = "";
		if (str.indexOf('&') != -1) {
			arr = str.split('&');
			for (var i = 0; i < arr.length; i++) {
				if (arr[i].split('=')[0] != ref) {
					returnurl = returnurl + arr[i].split('=')[0] + "=" + arr[i].split('=')[1] + "&";
				}
			}
			return url.substr(0, url.indexOf('?')) + "?" + returnurl.substr(0, returnurl.length - 1);
		} else {
			arr = str.split('=');
			if (arr[0] == ref)
				return url.substr(0, url.indexOf('?'));
			else
				return url;
		}
	},

	/* 
	 * obj 转 路由地址带参数
	 * 例子：{a:1,b:2} => /pages/index/index?a=1&b=2
	 */
	objParseUrlAndParam: function(path, obj) {
		let url = path || "/";
		let paramsStr = "";
		if (obj instanceof Array) return url;
		if (!(obj instanceof Object)) return url;
		paramsStr = this.objParseParam(obj);
		paramsStr && (url += "?");
		url += paramsStr;
		return url;
	},

	/* 
	 * obj 转 params字符串参数  
	 * 例子：{a:1,b:2} => a=1&b=2
	 */
	objParseParam: function(obj) {
		let paramsStr = "";
		if (obj instanceof Array) return paramsStr;
		if (!(obj instanceof Object)) return paramsStr;
		for (let key in obj) {
			paramsStr += `${key}=${obj[key]}&`;
		}
		return paramsStr.substring(0, paramsStr.length - 1);
	},

	SHA1: function(msg) {

		function rotate_left(n, s) {
			var t4 = (n << s) | (n >>> (32 - s));
			return t4;
		};

		function lsb_hex(val) {
			var str = "";
			var i;
			var vh;
			var vl;

			for (i = 0; i <= 6; i += 2) {
				vh = (val >>> (i * 4 + 4)) & 0x0f;
				vl = (val >>> (i * 4)) & 0x0f;
				str += vh.toString(16) + vl.toString(16);
			}
			return str;
		};

		function cvt_hex(val) {
			var str = "";
			var i;
			var v;

			for (i = 7; i >= 0; i--) {
				v = (val >>> (i * 4)) & 0x0f;
				str += v.toString(16);
			}
			return str;
		};


		function Utf8Encode(string) {
			string = string.replace(/\r\n/g, "\n");
			var utftext = "";

			for (var n = 0; n < string.length; n++) {

				var c = string.charCodeAt(n);

				if (c < 128) {
					utftext += String.fromCharCode(c);
				} else if ((c > 127) && (c < 2048)) {
					utftext += String.fromCharCode((c >> 6) | 192);
					utftext += String.fromCharCode((c & 63) | 128);
				} else {
					utftext += String.fromCharCode((c >> 12) | 224);
					utftext += String.fromCharCode(((c >> 6) & 63) | 128);
					utftext += String.fromCharCode((c & 63) | 128);
				}

			}

			return utftext;
		};

		var blockstart;
		var i, j;
		var W = new Array(80);
		var H0 = 0x67452301;
		var H1 = 0xEFCDAB89;
		var H2 = 0x98BADCFE;
		var H3 = 0x10325476;
		var H4 = 0xC3D2E1F0;
		var A, B, C, D, E;
		var temp;

		msg = Utf8Encode(msg);

		var msg_len = msg.length;

		var word_array = new Array();
		for (i = 0; i < msg_len - 3; i += 4) {
			j = msg.charCodeAt(i) << 24 | msg.charCodeAt(i + 1) << 16 |
				msg.charCodeAt(i + 2) << 8 | msg.charCodeAt(i + 3);
			word_array.push(j);
		}

		switch (msg_len % 4) {
			case 0:
				i = 0x080000000;
				break;
			case 1:
				i = msg.charCodeAt(msg_len - 1) << 24 | 0x0800000;
				break;

			case 2:
				i = msg.charCodeAt(msg_len - 2) << 24 | msg.charCodeAt(msg_len - 1) << 16 | 0x08000;
				break;

			case 3:
				i = msg.charCodeAt(msg_len - 3) << 24 | msg.charCodeAt(msg_len - 2) << 16 | msg.charCodeAt(
						msg_len - 1) << 8 |
					0x80;
				break;
		}

		word_array.push(i);

		while ((word_array.length % 16) != 14) word_array.push(0);

		word_array.push(msg_len >>> 29);
		word_array.push((msg_len << 3) & 0x0ffffffff);


		for (blockstart = 0; blockstart < word_array.length; blockstart += 16) {

			for (i = 0; i < 16; i++) W[i] = word_array[blockstart + i];
			for (i = 16; i <= 79; i++) W[i] = rotate_left(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);

			A = H0;
			B = H1;
			C = H2;
			D = H3;
			E = H4;

			for (i = 0; i <= 19; i++) {
				temp = (rotate_left(A, 5) + ((B & C) | (~B & D)) + E + W[i] + 0x5A827999) & 0x0ffffffff;
				E = D;
				D = C;
				C = rotate_left(B, 30);
				B = A;
				A = temp;
			}

			for (i = 20; i <= 39; i++) {
				temp = (rotate_left(A, 5) + (B ^ C ^ D) + E + W[i] + 0x6ED9EBA1) & 0x0ffffffff;
				E = D;
				D = C;
				C = rotate_left(B, 30);
				B = A;
				A = temp;
			}

			for (i = 40; i <= 59; i++) {
				temp = (rotate_left(A, 5) + ((B & C) | (B & D) | (C & D)) + E + W[i] + 0x8F1BBCDC) &
				0x0ffffffff;
				E = D;
				D = C;
				C = rotate_left(B, 30);
				B = A;
				A = temp;
			}

			for (i = 60; i <= 79; i++) {
				temp = (rotate_left(A, 5) + (B ^ C ^ D) + E + W[i] + 0xCA62C1D6) & 0x0ffffffff;
				E = D;
				D = C;
				C = rotate_left(B, 30);
				B = A;
				A = temp;
			}

			H0 = (H0 + A) & 0x0ffffffff;
			H1 = (H1 + B) & 0x0ffffffff;
			H2 = (H2 + C) & 0x0ffffffff;
			H3 = (H3 + D) & 0x0ffffffff;
			H4 = (H4 + E) & 0x0ffffffff;

		}

		var temp = cvt_hex(H0) + cvt_hex(H1) + cvt_hex(H2) + cvt_hex(H3) + cvt_hex(H4);

		return temp.toLowerCase();

	},

	
	getElapsedDay: function(params) {
		const date = new Date(params)
		var today = new Date();
		const day = parseInt((today.getTime() - date.getTime()) / (1000 * 60 * 60 * 24))
		const months = parseFloat(day / 30).toFixed(0);
		return months;

	},

	// 设置开始和结束时间 前6年后1年 
	// 宝宝生日的设置，使用到的页面有 register、baby
	getDate(type) {
		const date = new Date();
		let year = date.getFullYear();
		let month = date.getMonth() + 1;
		let day = date.getDate();

		if (type === 'start') {
			year = year - 18;
		} else if (type === 'end') {
			year = year + 1;
		}
		month = month > 9 ? month : '0' + month;
		day = day > 9 ? day : '0' + day;
		console.log("时间: " + `${year}-${month}-${day}`)

		return `${year}-${month}-${day}`;
	},

	// 判断当前时间点是否在规定的时间段中
	// beginTime, endTime, nowTime
	time_range: function() {
		// 白天版
		var beginTime = "06:00";
		var endTime = "17:59";
		// 当前时间
		var nowTime = new Date()
		var nowHour = nowTime.getHours()
		var nowMin = nowTime.getMinutes()



		var strb = beginTime.split(":");
		if (strb.length != 2) {
			return false;
		}

		var stre = endTime.split(":");
		if (stre.length != 2) {
			return false;
		}

		// var strn = nowTime.split(":");
		// if (stre.length != 2) {
		// 	return false;
		// }
		var b = new Date();
		var e = new Date();
		var n = new Date();

		b.setHours(strb[0]);
		b.setMinutes(strb[1]);
		e.setHours(stre[0]);
		e.setMinutes(stre[1]);
		n.setHours(nowHour);
		n.setMinutes(nowMin);
		// n.setHours(strn[0]);
		// n.setMinutes(strn[1]);

		if (n.getTime() - b.getTime() > 0 && n.getTime() - e.getTime() < 0) {
			console.log("当前时间是：" + n.getHours() + ":" + n.getMinutes() + "，在该时间范围内！");
			return true;
		} else {
			console.log("当前时间是：" + n.getHours() + ":" + n.getMinutes() + "，不在该时间范围内！");
			return false;
		}
	},

	// 判断当前日期是否在时间段中
	// 活动开始和结束日期
	betweenDay: function(beginDay, endDay) {
		// 当前时间
		var n = new Date()
		var b = new Date(beginDay)
		var e = new Date(endDay)
		console.log(n, b, e)
		// console.log(n.getTime(),b.getTime(),e.getTime())

		if (n.getTime() - b.getTime() > 0 && n.getTime() - e.getTime() < 0) {
			console.log("当前时间是：" + n + "，在该时间范围内！");
			return true;
		} else {
			console.log("当前时间是：" + n + "，不在该时间范围内！");
			return false;
		}
	},

	overTime: function(endDay) {
		// 当前时间
		var n = new Date()
		var e = new Date(endDay)

		if (n.getTime() < e.getTime()) {
			console.log("当前时间是：" + n + "，没有结束！");
			return true;
		} else {
			console.log("当前时间是：" + n + "，已结束！");
			return false;
		}
	},


	// 判断是否是微信
	isweixin() {
		var ua = navigator.userAgent.toLowerCase();
		console.log("当前环境：" + ua)

		if (ua.match(/micromessenger/i) == 'micromessenger') {
			return true;
		} else {
			return false;
		}
	},

	// 播放量 转成带文字的
	toChinese(d) {
		if (d > 10000) {
			return (d / 10000).toFixed(2) + "万"
		} else if (d > 1000) {
			return (d / 1000).toFixed(2) + "千"
		}
	},
	dataURLtoBlob(dataurl) {
		var arr = dataurl.split(','),
			mime = arr[0].match(/:(.*?);/)[1],
			bstr = atob(arr[1]),
			n = bstr.length,
			u8arr = new Uint8Array(n);
		while (n--) {
			u8arr[n] = bstr.charCodeAt(n);
		}
		return new Blob([u8arr], {
			type: mime
		});
	},
	imageCompress(url, cb) {
		let _this = this;
		let image = new Image();
		image.src = url;

		image.onload = img => {
			let canvas = document.createElement("canvas");
			let ctx = canvas.getContext("2d");

			// var imageLength = this.src.length;
			var originWidth = image.width;
			var originHeight = image.height;

			var maxWidth = 800,
				maxHeight = 800;
			// 目标尺寸
			var targetWidth = originWidth,
				targetHeight = originHeight;

			// 图片尺寸超过800x800的限制
			if (originWidth > maxWidth || originHeight > maxHeight) {
				if (originWidth / originHeight > maxWidth / maxHeight) {
					// 更宽，按照宽度限定尺寸
					targetWidth = maxWidth;
					targetHeight = Math.round(maxWidth * (originHeight / originWidth));
				} else {
					targetHeight = maxHeight;
					targetWidth = Math.round(maxHeight * (originWidth / originHeight));
				}
			}

			canvas.width = ctx.width = targetWidth
			canvas.height = ctx.height = targetHeight

			ctx.clearRect(0, 0, targetWidth, targetHeight)
			ctx.drawImage(image, 0, 0, targetWidth, targetHeight)

			let dataUrl = canvas.toDataURL("image/jpeg", 0.9);
			let blob = _this.dataURLtoBlob(dataUrl);
			cb(blob);
		}
	},


	
	randomRange(min, max){
		var returnStr = "",
			range = (max ? Math.round(Math.random() * (max-min)) + min : min),
			charStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
			
		for(var i=0; i<range; i++){
			var index = Math.round(Math.random() * (charStr.length-1));
			returnStr += charStr.substring(index,index+1);
		}
		return returnStr;
	}

}

export default utils;
